import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { LeafSprig } from "../Ornaments";

export function Supporters() {
  return (
    <section className="support" aria-labelledby="support-title">
      <div className="container">
        <div className="support-frame">
          <div className="support-label">
            <LeafSprig className="support-leaf" />
            <h2 id="support-title">Supported by</h2>
          </div>
          <span className="support-divider" aria-hidden="true" />
          {/* Original Adani Foundation logo file */}
          <img
            className="support-logo"
            src="/images/adani-foundation-logo.png"
            alt="Adani Foundation"
            width={213}
            height={140}
            loading="lazy"
          />
          <span className="support-divider" aria-hidden="true" />
          <p className="support-text">
            The Adani Foundation has been instrumental in supporting our mission
            to digitize, preserve, and share the Jain heritage.
          </p>
          <Link
            to="/about/adani-shantigram"
            className="btn btn-outline support-btn"
          >
            About Support
            <ArrowRight aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}
